import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import intlTelInput, { Iti } from 'intl-tel-input';
import { wait$ } from '../../omt-lib';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-ui-phone-number-input',
  templateUrl: './ui-phone-number-input.component.html',
  styleUrls: ['./ui-phone-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: UiPhoneNumberInputComponent,
    },
  ],
  standalone: false,
})
export class UiPhoneNumberInputComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor
{
  @Input() _label = '';
  @Input() _id = '';
  @Input() _placeholder = '';
  @Input() _required = false;
  @Input() _disabled = false;
  @Input() initialCountry = 'za';
  @Input() innerModel = '';
  @Output() innerModelChange = new EventEmitter<string>();
  @Output() dialingCodeChange = new EventEmitter<string>();

  onChange = (value: any) => {};
  onTouched = () => {};

  touched = false;
  disabled = false;

  writeValue(value: any): void {
    this.innerModel = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  updateValue(value: string) {
    this.innerModel = value;
    this.onChange(value);
    this.innerModelChange.emit(value);
  }

  passOnTouched(event: any) {
    this.markAsTouched();
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  private _iti: Iti | null = null;

  constructor() {}

  public onNgModelChange(value: string) {
    this.onChange(value);
    if (this._iti && value) {
      const rValue = value.replace(/[^0-9\+]/g, '');
      if (rValue !== value) {
        this._el!.value = rValue;
        value = rValue;
      }

      if (this.innerModel !== value) {
        this.innerModel = value;
        this.innerModelChange.emit(this._iti.getNumber());
        this._el!.value = this._iti.getNumber();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['_ngModel']) {
      this.onNgModelChange(changes['_ngModel'].currentValue);
    }
    if (changes['initialCountry'] && this._iti && this._el) {
      this._iti.setCountry(this.initialCountry);
      this._el.value = this._iti!.getNumber();
    }
  }

  ngOnInit(): void {}

  private _el: HTMLInputElement | null = null;
  async ngAfterViewInit() {
    await wait$(125);
    this._el = document.querySelector<HTMLInputElement>(`#${this._id}`)!;
    this._iti = intlTelInput(this._el, {
      allowDropdown: false,
      utilsScript: '/assets/js/intl-tel-input-utils.js',
      nationalMode: false,
      formatAsYouType: false,
      formatOnDisplay: false,
      showFlags: false,
      customPlaceholder: () => '',
    });

    this._el.addEventListener('countrychange', (e) => {
      this.dialingCodeChange.emit(this._iti!.getSelectedCountryData().iso2);
    });

    this._el.addEventListener('open:countrydropdown', (e) => {});
    this._el.addEventListener('close:countrydropdown', (e) => {});

    await wait$(125);

    if (this._el.value.trim().startsWith('0') || !this._el.value) {
      this._iti.setCountry(this.initialCountry);
      this._el.value = this._iti!.getNumber();
    }

    this.onNgModelChange(this._iti!.getNumber());
  }

  ngOnDestroy(): void {
    this._iti?.destroy();
  }
}
